import api from './config';

/**
 * 获取歌曲列表
 * @param {Object} params 查询参数
 */
export function getSongs(params = {}) {
  return api.get('/songs', { params });
}

/**
 * 获取歌曲详情
 * @param {string} id 歌曲ID
 */
export function getSongById(id) {
  return api.get(`/songs/${id}`);
}

/**
 * 创建歌曲
 * @param {Object} data 歌曲数据
 */
export function createSong(data) {
  return api.post('/songs', data);
}

/**
 * 更新歌曲
 * @param {string} id 歌曲ID
 * @param {Object} data 歌曲数据
 */
export function updateSong(id, data) {
  return api.put(`/songs/${id}`, data);
}

/**
 * 删除歌曲
 * @param {string} id 歌曲ID
 */
export function deleteSong(id) {
  return api.delete(`/songs/${id}`);
}

/**
 * 上传歌曲/歌词文件（新接口）
 * 后端路由：POST /api/songs/upload
 *
 * 注意：音频文件需要服务端调用 ffmpeg 转码，可能比较耗时，
 * 所以这里单独把超时时间调大一些（默认全局是 10 秒）。
 */
export function uploadSongFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/songs/upload', formData, {
    timeout: 120000, // 120 秒，避免多个文件转码时前端过早超时
  });
}